export default __webpack_public_path__ + "static/media/tokyo.c42c40c9.jpg";